import { render, staticRenderFns } from "./CopyFromTemplate.vue?vue&type=template&id=4d730aa0"
import script from "./CopyFromTemplate.vue?vue&type=script&lang=js"
export * from "./CopyFromTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports